<template>
	<footer class="footer">
		<div class="row">
			<div class="social" v-if="!isNativeDevice" v-html="blockContent" />
			<ul class="footer-menu">
				<li v-for="(item, key) in footer_menu" :key="key" v-focus-section>
					<router-link
						v-if="item.attributes.url !== '#user'"
						:to="`/${item.attributes.url.split('#')[1]}`"
						v-focus
						class="vl-font-size--16"
						:class="item?.attributes?.options?.attributes?.class[0]"
						rel="noopener noreferrer"
						>{{ item.attributes.title }}</router-link
					>
					<a
						v-else
						:href="`${url}/${item.attributes.url.split('#')[1]}`"
						v-focus
						class="vl-font-size--16"
						rel="noopener noreferrer"
						>{{ item.attributes.title }}</a
					>
				</li>
				<li>
					<button v-focus @click="showCookiePrefs()">{{ $t("cookieConsent.manageCookies") }}</button>
				</li>
			</ul>

			<span v-if="isNativeDevice" class="app-version"> {{ $t("app.version") }}: {{ appVersion }}</span>
		</div>
		<!-- <img fetchpriority="high" decoding="async" src="../images/footer-logo.png" class="footer-logo" alt="footer-logo" /> -->
	</footer>
</template>

<script lang="ts" setup>
	import * as CookieConsent from "vanilla-cookieconsent"
	import { computed, ref, onMounted } from "vue"
	import { useMovieStore } from "../stores/movies"
	import axios from "axios"
	import { useI18n } from "vue-i18n"
	import { url, appVersion } from "../helper"
	import { useDeviceManager } from "../stores/deviceManager"
	import config from "./cookieconsent-config"

	const deviceManager = useDeviceManager()
	const movieStore = useMovieStore()
	const social = ref([])
	const footer_menu = ref([])
	const blockContent = ref("")
	const { locale } = useI18n()

	const isNativeDevice = computed(() => {
		return deviceManager.deviceInfo.platform !== "web"
	})

	const showCookiePrefs = () => {
		const configs = config(locale.value)
		CookieConsent.run(configs)
	}

	const getSocialMedia = async () => {
		try {
			await axios
				.get(`${url}/${locale.value}/jsonapi/block_content/basic?filter[langcode]=${locale.value}`, {})
				.then((res) => {
					social.value = res.data.data
					const rawHtml = social.value[0]?.attributes?.body?.processed
					blockContent.value = fixImagePaths(rawHtml)
				})
		} catch (error) {
			console.log(error)
		}
	}

	const getFooterMenu = async () => {
		try {
			await axios
				.get(`${url}/${locale.value}/jsonapi/menu_items/footer?filter[langcode]=${locale.value}`, {})
				.then((res) => {
					footer_menu.value = res.data.data
				})
		} catch (error) {
			console.log(error)
		}
	}
	getSocialMedia()
	getFooterMenu()
	const fixImagePaths = (html: unknown): string => {
		if (typeof html !== "string") {
			return ""
		}

		return html.replace(/<img\s+[^>]*src="(\/[^"]+)"/g, (match, src) => {
			return match.replace(src, `${url}${src}`)
		})
	}
</script>

<style lang="scss" scoped>
	footer {
		margin-top: 80px;
		padding-bottom: 40px;

		// @include br.tablet-down {
		// 	display: none;
		// }
		// min-height: 314px;
	}
	.row {
		display: flex;
		flex-direction: column;
		gap: 40px;
		margin: 60px 0 0 0;
		justify-content: center;
		align-items: center;

		@include br.respond-to(br.$tablet-xlarge) {
			margin-bottom: 60px;
		}
	}
	.footer {
		&-menu {
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0;
			margin: 0px;

			@include br.respond-to(br.$tablet-xlarge) {
				flex-direction: column;
				gap: 20px;
			}
			li {
				list-style: none;
				margin-right: 38px;

				@include br.respond-to(br.$tablet-xlarge) {
					margin-right: 0;
				}

				&:nth-child(2n) {
					margin-right: 100px;
					@include br.respond-to(br.$tablet-xlarge) {
						margin-right: 0;
					}
				}
			}
			a {
				text-decoration: none;
				&:hover {
					opacity: 0.8;
				}
			}
		}
		&-logo {
			display: block;
			margin: 125px auto 0 auto;
		}
	}
	// .footer-logo {
	//   width: 100%;
	//   height: 70px;
	//   background-image: url('../images/footer-logo.png');
	//   background-size: contain;
	//   background-repeat: no-repeat;
	//   background-position: center;
	// }
</style>

<style lang="scss">
	.social {
		display: flex;
		align-items: center;
		gap: 38px;
		a {
			width: fit-content;
			text-align: center;
		}
		img {
			width: auto;
			max-height: 25px;
			height: auto;
		}
	}
</style>
